import React, { useEffect, useState } from 'react';

import './styles.scss'

import { Link } from 'react-router-dom';

import dataFoot from '../../assets/fake-data/data-foot';

function SubFooter(props) {

    const [isVisible, setIsVisible] = useState(false);

    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    };
  
    useEffect(() => {
      const toggleVisibility = () => {
        if (window.pageYOffset > 500) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      };
  
      window.addEventListener("scroll", toggleVisibility);
  
      return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);
    return (
        <footer id="subfooter">
        <div className="footer-bottom">
                <div className="footcontent">
                <div className="contact">
                    <div className="phone   ">官网热线：<span className="bold">400-9202-505</span>
                    </div>
                    <div className="phone   ">产品热线：<span className="bold">400-6168-660</span>
                    </div>
                    <div className="copyright">
                            Copyright © 2015 上海德联车护网络发展有限公司
                            <a className="marginLeft" href="https://beian.miit.gov.cn" target="_blank" >沪ICP备15027623号-1</a>
                        <a href="#">危险化学品经营许可证编号：沪(闵)应急管危经许[2021]204354</a>

                    </div>
                </div>
                <div className="qrcode">
                    <div className="qrcode1">
                            <img src={dataFoot.img1} />
                            德联事业部公众号
                    </div>
                    <div className="qrcode1">
                            <img src={dataFoot.img2} />
                            BASF事业部公众号
                    </div>
                </div>
            </div>            
        </div>

        {
                isVisible && 
                <Link onClick={scrollToTop}  to='#' id="scroll-top"></Link>
            }
    </footer>
    );
}

export default SubFooter;